import DossierAttachmentForm from "./DossierAttachmentForm";

export default class SimpleAttachmentForm extends DossierAttachmentForm {
}

SimpleAttachmentForm.defaultProps = {
  hideTime: true
}
